import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'semantic-ui-react';
import SpeakerHeader from '../components/speakers/SpeakerHeader';
import WorkshopsMatchingBlock from '../components/workshops/WorkshopsMatchingBlock';
import { bem } from '../core/design/bem';
import PageMeta from '../core/metadata/PageMeta';
import { trackModal } from '../core/trackers';
import { useSpeaker } from '../core/users/users.hooks';
import './SpeakerModal.scss';

const css = bem('SpeakerModal');

const SpeakerModal = (props) => {
  const { onClose, showHeader, speakerId, variant, workshopConfig, metadata, ...modalConfig } = props;
  const { showSessions, template } = workshopConfig;
  const { t } = useTranslation();
  const speaker = useSpeaker(speakerId);
  useEffect(() => {
    trackModal(modalConfig, speaker);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalConfig.type, modalConfig.modalKey, speaker]);
  if (!speaker) return null;

  return (
    <Modal
      size="small"
      className={css({ variant, visibleHeader: showHeader }).toString()}
      open
      closeIcon
      onClose={() => onClose({ speakerId: undefined, modal: undefined })}
    >
      {metadata && <PageMeta {...metadata} item={speaker} />}
      {showHeader && (
        <Modal.Header className={css({ header: true }).toString()}>
          {t('speakers.modal.header', { ...speaker })}
        </Modal.Header>
      )}
      <Modal.Content scrolling>
        <SpeakerHeader
          {...modalConfig}
          speaker={{ ...speaker, description: speaker?.fullDescription || speaker?.description }}
          variant={variant}
        />
        {showSessions && (
          <WorkshopsMatchingBlock
            field="speakers"
            value={speaker._id}
            template={template}
            itemProps={workshopConfig}
          />
        )}
      </Modal.Content>
    </Modal>
  );
};

SpeakerModal.defaultProps = {
  variant: undefined,
  showHeader: false,
  onClose: undefined,
  modalConfig: {},
  workshopConfig: {},
};

SpeakerModal.propTypes = {
  modalConfig: PropTypes.object,
  onClose: PropTypes.func,
  showHeader: PropTypes.bool,
  speakerId: PropTypes.string.isRequired,
  variant: PropTypes.string,
  workshopConfig: PropTypes.object,
};

export default SpeakerModal;
